/**
 * Clincal Trials Map.
 * 
 */

/**
 * Modify MapSVG markup to enable Details View styling in desktop views.
 * Use MapSVG native close button.
 * NB. JS associated with map is saved via WordPress > MapSVG > Javascript.
 * 
 * Define interactivity of excol content in mobile views.
 */

let 
	$window = $(window),
	$excolButtons = $('.trials-list__state.button-excol'),
	$myBtn,
	$myContent,
	$currBtn,
	$currContent,
	$myBlock,
	$currBlock;

	function initExColButtons() {
	// console.log('TRIALS: initExColButtons()');

	$excolButtons.on('click', function() {
		console.log('CLICK: '+$(this));
		$myBtn = $(this);
		$myContent = $myBtn.next();
		$currBtn = $excolButtons.filter('.expanded');
		$currContent = $currBtn.next();

		if ($myBtn.hasClass('expanded')) {
			// Collapse this State.
			$myBtn.removeClass('expanded');
			$myContent.slideUp(300);
		} else {
			// Collapse current expanded State, expand this State.
			$currBtn.removeClass('expanded');
			$currContent.slideUp(300);
			$myBtn.addClass('expanded');
			$myContent.slideDown(300);
		}
	});
}

 exports.init = function () {
	// console.log('TRIALS: exports.init');
    // Run init methods...

	initExColButtons();
};